import React, { useMemo } from 'react';
import LoanArrearsSC, { DataArrearsSC } from './loan-arrears.styled';
import { BodyText, HeadingFour, BiggerText } from '../../typography';
import SmallText from '../../typography/small-text';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import numeral from 'numeral';
import Moment from 'react-moment';

const LoanArrears = ({ daysInArrears, actualUnpaid, schedules }) => {
  const inArrears = useMemo(() => schedules.filter((loan) => loan[12] > 0), [schedules]);
  return (
    <LoanArrearsSC>
      <DataArrearsSC>
        <div>
          <div className="headline-data-wrap">
            <BodyText className="bolder">
              <FormattedMessage
                id="investor_loan_detail_arrears_headline"
                defaultMessage={dlt['investor_loan_detail_arrears_headline']}
              />
            </BodyText>
            <BodyText>
              <FormattedMessage
                id="investor_loan_detail_arrears_delay"
                defaultMessage={dlt['investor_loan_detail_arrears_delay']}
              />{' '}
              <b>
                {daysInArrears === 1 ? (
                  <>
                    {daysInArrears}{' '}
                    <FormattedMessage id="global_day" defaultMessage={dlt['global_day']} />
                  </>
                ) : daysInArrears > 4 || daysInArrears === 0 ? (
                  <>
                    {daysInArrears}{' '}
                    <FormattedMessage id="global_days" defaultMessage={dlt['global_days']} />
                  </>
                ) : (
                  <>
                    {daysInArrears}{' '}
                    <FormattedMessage
                      id="global_more_days"
                      defaultMessage={dlt['global_more_days']}
                    />{' '}
                  </>
                )}
              </b>
            </BodyText>
          </div>
          <div className="body-data-wrap">
            {inArrears.length === 0 ? null : (
              <div className="body-data-wrap--item">
                <SmallText className="black-transparent">
                  <FormattedMessage
                    id="investor_loan_detail_arrears_in_arrears"
                    defaultMessage={dlt['investor_loan_detail_arrears_in_arrears']}
                  />
                </SmallText>

                {inArrears.map((loan) => {
                  return (
                    <div
                      key={loan[0]}
                      className={loan[15] !== '' || loan[18] !== '' ? 'full-arrear' : ''}
                    >
                      <div className="body-data-wrap--item__body-row">
                        <BodyText className="bolder">
                          <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                            {loan[1]}
                          </Moment>
                        </BodyText>
                        <BodyText className="bolder red">
                          {numeral(Number(loan[9]) + Number(loan[10])).format('0,00.00')} €
                        </BodyText>
                      </div>
                      {loan[15] !== '' ? (
                        <div className="body-data-wrap--item__body-row padded-small">
                          <SmallText>
                            <FormattedMessage
                              id="investor_loan_detail_arrears_interest_late"
                              defaultMessage={dlt['investor_loan_detail_arrears_interest_late']}
                            />
                          </SmallText>
                          <SmallText className="red">
                            {numeral(Number(loan[15])).format('0,00.00')} €
                          </SmallText>
                        </div>
                      ) : null}

                      {loan[18] !== '' ? (
                        <div className="body-data-wrap--item__body-row padded-small">
                          <SmallText>
                            <FormattedMessage
                              id="investor_loan_detail_arrears_contractual_penalty"
                              defaultMessage={
                                dlt['investor_loan_detail_arrears_contractual_penalty']
                              }
                            />
                          </SmallText>
                          <SmallText className="red">
                            {numeral(Number(loan[18])).format('0,00.00')} €
                          </SmallText>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="summary-wrap">
          <div className="summary-wrap--amount">
            <>
              <BiggerText>
                <FormattedMessage
                  id="investor_loan_detail_arrears_summary"
                  defaultMessage={dlt['investor_loan_detail_arrears_summary']}
                />
              </BiggerText>

              <HeadingFour className={Number(actualUnpaid) === 0 ? null : 'red'}>
                {numeral(Number(actualUnpaid)).format('0,0.00')} €
              </HeadingFour>
            </>
          </div>
        </div>
      </DataArrearsSC>
    </LoanArrearsSC>
  );
};

export default LoanArrears;
